<div class="symbol">
  <div
    class="image-input image-input-outline image-input-circle border border-secondary"
    id="kt_image_3"
  >
    <div>
      <img
        class="image-input-wrapper"
        [id]="user?.userName"
        [style.width.px]="size"
        [style.height.px]="size"
        src="{{ photoUrl }}"
      />
      <i
        *ngIf="fromTeamMemList"
        [ngClass]="userIsActive ? 'symbol-badge bg-success' : 'symbol-badge bg-danger'"
      ></i>
    </div>
    <label
      *ngIf="editable"
      class="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow"
      data-action="change"
      data-toggle="tooltip"
      title=""
      data-original-title="Change avatar"
    >
      <i class="fa fa-pen icon-sm text-muted"></i>
      <input
        #fileInput
        type="file"
        (change)="onFileChange($event)"
        name="profile_avatar"
        accept=".png, .jpg, .jpeg"
      />
      <input type="hidden" name="profile_avatar_remove" />
    </label>
  </div>
</div>
